import React, { useEffect, useState } from "react";
import "./index.css";
import ToastMessage from "../../utils/ToastMessage";
import {
  ImageUrl,
  invoiceURL,
  orderDetails,
  postApiCall,
} from "../../API/baseUrl";
import { useParams } from "react-router-dom";
import Loader from "../../components/loader";
import moment from "moment";
import ReviewForm from "../../Componentsnew/Review";
import { Button, Modal } from "react-bootstrap";
import { Divider, Grid, Rating } from "@mui/material";
import { Avatar, Paper } from "@material-ui/core";
import { slugify } from "../../Componentsnew/URL/Index";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Stack,
  Chip,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

// Example status color mapping
const statusColors = {
  Delivered: "success",
  Dispatched: "info",
  Accepted: "primary",
  Cancelled: "error",
};
const OrderDetails = () => {
  const navigate = useNavigate();

  const { id } = useParams();
  const [details, setDetails] = useState({});
  const [data, setData] = useState([]);
  const [pending, setPending] = useState(false);
  const [userId, setUserId] = useState(null);
  const [productId, setProductId] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [ratingvalue, setratingValue] = useState(0);
  const handleOpen = (productId) => {
    setSelectedProductId(productId);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const getDetails = async () => {
    setPending(true);
    try {
      const result = await postApiCall(`${orderDetails}/${id}`);
      if (result?.data?.status) {
        const UserId = result?.data?.data?.userId;
        setUserId(UserId);
        setDetails(result?.data?.data);
        setData(result?.data?.data?.All_Orderd_Product);
        console.log(result?.data?.data, "result?.data?.data");
      } else {
        ToastMessage("error", result.data.message);
      }
    } catch (error) {
      // Handle error
    } finally {
      setPending(false);
    }
  };

  useEffect(() => {
    getDetails();
  }, []);

  const handleInvoice = () => {
    window.open(`${invoiceURL}${details.invoice_url}`, "_blank");
  };
  console.log(details?.invoice_url, "invoice_url");

  const handleDetailPage = (id, name) => {
    const cleanedName = slugify(name);
    navigate(`/productDetails/${id}/${cleanedName}`);
  };
  // const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <>
      <Grid
        style={{
          width: "80vw",
          // padding: "20px",
          display: "flex",
          margin: "auto",
          justifyContent: "space-between",
          flexDirection: "column",
        }}
      >
        <Grid item>
          {pending ? (
            <Loader />
          ) : (
            <Paper
              elevation={3}
              sx={{
                padding: "30px",
                borderRadius: 3,
                backgroundColor: "#fff",
              }}
            >
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={4}
                justifyContent="space-between"
                sx={{
                  padding: "30px",
                }}
              >
                {/* Delivery Address */}
                <Box sx={{ flex: 1 }}>
                  <Typography
                    variant="h6"
                    color="var(--primary-color)"
                    gutterBottom
                  >
                    Delivery Address
                  </Typography>
                  <Typography variant="subtitle1" fontWeight="bold">
                    {details.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {details.address}, {details.city}, {details.state} -{" "}
                    {details.addressType}
                  </Typography>
                  <Typography variant="body2" mt={1}>
                    <strong>Phone:</strong> {details.mobile}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Email:</strong> {details.email}
                  </Typography>
                </Box>

                {/* Order Info */}
                <Box sx={{ flex: 1 }}>
                  <Stack spacing={2}>
                    <Stack direction="row">
                      <Typography
                        variant="subtitle2"
                        style={{ marginRight: "10px" }}
                        color="text.secondary"
                      >
                        Order On
                      </Typography>
                      <Typography variant="body1">
                        {moment(details.Date).format("MMMM Do YYYY")}
                      </Typography>
                    </Stack>

                    <Stack direction="row">
                      <Typography
                        variant="subtitle2"
                        style={{ marginRight: "10px" }}
                        color="text.secondary"
                      >
                        Order Status
                      </Typography>
                      <Chip
                        label={details.orderStatus}
                        color={statusColors[details.orderStatus] || "default"}
                        variant="outlined"
                        sx={{
                          fontWeight: 600,
                          textTransform: "capitalize",
                          "&:hover": { boxShadow: 2 },
                        }}
                      />
                    </Stack>

                    <Stack direction="row">
                      <Typography
                        variant="subtitle2"
                        style={{ marginRight: "10px" }}
                        color="text.secondary"
                      >
                        Delivery Charge
                      </Typography>
                      <Typography
                        variant="body1"
                        color={
                          details.delivery_charge === "Free"
                            ? "success.main"
                            : "text.primary"
                        }
                      >
                        {details.delivery_charge === "Free" ? (
                          "Free"
                        ) : (
                          <>
                            <CurrencyRupeeIcon
                              sx={{ fontSize: "16px", verticalAlign: "middle" }}
                            />
                            {Number(details.delivery_charge || 0).toFixed(2)}
                          </>
                        )}
                      </Typography>
                    </Stack>

                    <Stack direction="row">
                      <Typography
                        variant="subtitle2"
                        style={{ marginRight: "10px" }}
                        color="text.secondary"
                      >
                        Order Total
                      </Typography>
                      <Typography variant="body1" fontWeight="bold">
                        <CurrencyRupeeIcon
                          sx={{ fontSize: "16px", verticalAlign: "middle" }}
                        />
                        {Number(details.total_order_amount).toFixed(2)}
                      </Typography>
                    </Stack>
                  </Stack>
                </Box>
              </Stack>

              {/* Invoice Button */}
              <Box display="flex" justifyContent="center" mt={2}>
                <button className="invoice_btn" onClick={handleInvoice}>
                  Download Invoice
                </button>
              </Box>
            </Paper>
          )}
        </Grid>

        <Grid item xs={12} md={6} mt={2}>
          {data.map((product, index) => (
            <Paper
              key={index}
              elevation={2}
              sx={{ p: 2, mb: 3, borderRadius: 2 }}
            >
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={4}
                justifyContent="space-between"
              >
                <Grid container spacing={2} alignItems="flex-start">
                  {/* Image */}
                  <Grid item>
                    <Box
                      component="img"
                      src={`${ImageUrl}${product.files}`}
                      alt="Product"
                      sx={{
                        width: 100,
                        height: 100,
                        borderRadius: 2,
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        handleDetailPage(
                          product.productId || product.id,
                          product.product_name || product.productName
                        )
                      }
                    />
                  </Grid>

                  {/* Product Details */}
                  <Grid item xs>
                    <Box sx={{}}>
                      <Typography variant="h6" gutterBottom>
                        {product.product_name || "-"}
                      </Typography>

                      <Typography variant="body2" color="text.secondary">
                        Color:{" "}
                        {product.color_name === "FreeColor"
                          ? "FreeColor"
                          : product.color_name || "-"}
                      </Typography>

                      <Typography variant="body2" color="text.secondary">
                        Size:{" "}
                        {product.product_size === "FreeSize"
                          ? "Free Size"
                          : product.product_size || "-"}
                      </Typography>

                      <Typography variant="body2" color="text.secondary">
                        Quantity: {product.quantity || "-"}
                      </Typography>

                      <Typography variant="body2" fontWeight="bold" mt={1}>
                        Price: ₹{" "}
                        {product.discount_percent === 0
                          ? product.mrp_amount
                          : product.discount_amount}
                      </Typography>

                      {/* Rating / Review */}
                      {product.ratingData?.isProductRated === 1 ? (
                        <Box mt={2}>
                          <Typography variant="subtitle1" fontWeight="bold">
                            Your Review
                          </Typography>
                          <Box display="flex" alignItems="flex-start" mt={1}>
                            <Avatar
                              alt={product.ratingData.name}
                              src="/static/images/avatar/1.jpg"
                              sx={{ width: 48, height: 48 }}
                            />
                            <Box ml={2}>
                              <Typography variant="body1">
                                {product.ratingData.name}
                              </Typography>
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                {product.ratingData.email}
                              </Typography>
                              <Rating
                                value={parseFloat(product.ratingData.rating)}
                                readOnly
                                sx={{ mt: 0.5 }}
                              />
                              <Typography
                                variant="body2"
                                mt={1}
                                style={{
                                  marginBottom: "20px",
                                }}
                              >
                                {product.ratingData.comment}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      ) : (
                        <Box
                          mt={2}
                          onClick={() => handleOpen(product.productId)}
                        >
                          <Rating
                            name={`product-rating-${index}`}
                            value={ratingvalue}
                            onChange={(event, newValue) =>
                              setratingValue(newValue)
                            }
                          />
                        </Box>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </Stack>
            </Paper>
          ))}
        </Grid>
      </Grid>
      <Modal
        show={open}
        onHide={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        centered
      >
        <Box
          style={{
            backgroundColor: "background.paper",
            padding: 3,
            borderRadius: 2,
            boxShadow: 24,
            maxWidth: 500,
            width: "100%",
            textAlign: "center",
          }}
        >
          <ReviewForm
            orderid={id}
            userId={userId}
            productId={selectedProductId}
            handleClose={handleClose}
            ratingvalue={ratingvalue}
            getDetails={getDetails}
          />
          {console.log("ratingvalue", ratingvalue)}
        </Box>
      </Modal>
    </>
  );
};

export default OrderDetails;
